import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const useAgentUpdates = () => {
  const { toast } = useToast();

  const updateAgentPrompt = async (agentId: number, prompt: string) => {
    try {
      const { error } = await supabase
        .from('ai_agents')
        .update({ prompt })
        .eq('id', agentId);

      if (error) throw error;

      toast({
        title: "Prompt atualizado",
        description: "O prompt do agente foi atualizado com sucesso!",
      });
    } catch (error) {
      console.error('Error updating prompt:', error);
      toast({
        title: "Erro ao atualizar prompt",
        description: "Houve um erro ao atualizar o prompt do agente.",
        variant: "destructive",
      });
    }
  };

  const updatePreferredApi = async (agentId: number, preferredApi: "mistral" | "openai") => {
    try {
      const { error } = await supabase
        .from('ai_agents')
        .update({ preferred_api: preferredApi })
        .eq('id', agentId);

      if (error) throw error;

      toast({
        title: "API preferida atualizada",
        description: "A API preferida do agente foi atualizada com sucesso!",
      });
    } catch (error) {
      console.error('Error updating preferred API:', error);
      toast({
        title: "Erro ao atualizar API preferida",
        description: "Houve um erro ao atualizar a API preferida do agente.",
        variant: "destructive",
      });
    }
  };

  return {
    updateAgentPrompt,
    updatePreferredApi,
  };
};